export class Dialog {
  constructor(
    public description: string,
    public image: string,
    public audio: string | null = null,
    public callback: () => void = () => { }
  ) { }
}

export interface IScene {
  name: string;
  key: number;
  preloadAssets: string[];
  audio: string | null;
  loading: boolean;
  navigate: (next: Promise<IScene>) => Promise<void>;
}

export class Quest {
  constructor(public description: string) { }
}

export class Storylines {
  findBag = true;
  findSupermarket = false;
  acquireSupplies = false;
  buyDiapers = false;
  seekRevenge = false;
  findGlenn = false;
  dogHasBeenTamed = false;
  fenceOpened = false;
  dogDistracted = false;
  darethDemoted = false;
  findAtm = false;
  burgerPurchased = false;
  infectedWithYogid = false;
  bittenBySpider = false;
  employeesFled = false;
  eavesdropped = false;
  goneToShibariOffice = false;
  tameDog = false;
  atmFound = false;
}

let storylines = new Storylines();

export class Choice {
  constructor(public name: string, public action: any) { }
}

export class Item {
  constructor(
    public description: string,
    public icon: string,
    public has: boolean = false
  ) { }
}

export class Inventory {
  cash = new Item("Cash", require("@/icons/50-note.gif"), true);
  bag = new Item("Colesworth Bag", require("@/icons/bag.gif"));
  beans = new Item("Can of Beans", require("@/icons/beans.gif"));
  toiletPaper = new Item("Toilet Paper", require("@/icons/tp.gif"));
  handSanitizer = new Item("Hand Sanitizer", require("@/icons/sanitizer.gif"));
  glenn = new Item("Glenn", require("@/icons/glenn.gif"));
  diapers = new Item("Adult Diapers", require("@/icons/diapers.gif"));
  burger = new Item("Famous Big Burger", require("@/icons/burger.gif"));
  creditCard = new Item("Credit Card", require("@/icons/card.gif"));
  key = new Item("Key", require("@/icons/key.gif"));
  tongs = new Item("Tongs", require("@/icons/tongs.gif"));
  shibariKeyCard = new Item(
    "Shibari International Key Card",
    require("@/icons/keycard.gif")
  );
  darethsOfficeKey = new Item(
    "Dareth's Office Key",
    require("@/icons/key.gif")
  );
  facemask = new Item("Disposable Face Mask", require("@/icons/mask.gif"));
}

export class CustomScene implements IScene {
  constructor(
    public name: string,
    public navigateTo: Promise<IScene>,
    public audio: string = ""
  ) {
    this.key = Math.random();
    this.navigate = async () => undefined;
  }

  loading = false;
  navigate: (next: Promise<IScene>) => Promise<void>;
  key: number;
  preloadAssets = [];
  actualImages = [];
}

export class State {
  constructor(
    public inventory: Inventory,
    public storylines: Storylines,
    public finished: boolean = false
  ) { }
}

export const state = new State(new Inventory(), new Storylines());

export const newState = () => new State(new Inventory(), new Storylines());

export class Scene implements IScene {
  showInput = false;
  dialogs: Dialog[] = [];

  navigate: (scene: Promise<IScene>) => Promise<void> = async () => undefined;

  constructor() { }

  state: State = state;

  async init() { }

  preloadAssets: string[] = [];

  name: string = this.constructor.name;
  title: string = "";
  image: string = "";
  loading = false;
  description: string = "";

  isRunningDialog = false;

  audioKey: string = `${Math.random()}`;

  audio: string | null = null;

  isFullscreen = false;

  get options(): Choice[] {
    return [];
  }

  dialogIndex = 0;

  async nextDialog() {
    if (this.dialogIndex >= this.dialogs.length) {
      this.dialogs = [];
      this.isRunningDialog = false;
      if (this.finishDialog) {
        this.finishDialog();
      }
    } else {
      let dialog = this.dialogs[this.dialogIndex];
      this.description = dialog.description;
      this.image = dialog.image;
      this.audio = dialog.audio;
      this.audioKey = `${Math.random()}`;
      dialog.callback();
    }
    this.dialogIndex++;
  }

  async dialogRunner(dialogs: Dialog[]) {
    this.isRunningDialog = true;
    this.dialogs = dialogs;
    this.dialogIndex = 0;

    return new Promise<void>((resolve) => {
      this.finishDialog = resolve
      this.nextDialog();
    })
  }

  finishDialog?: () => void
  key: number = 1;
}
